module.exports = __webpack_public_path__ + "img/462.7107aeb4.png";